import React, { useState } from 'react';
import { Input, Button, Select, message, Modal, Result, Checkbox } from 'antd'
import useSWR from 'swr'
import CopyToClipboard from 'react-copy-to-clipboard';
import classnames from 'classnames';
import { TbFormItem, TbButton } from '../components';
import useStatistic, { useClickStatistic } from '../hooks/useStatistic';
import { generateShortUrl } from '../../../api/taobao';
import PageLoading from './PageLoading'
import Line from './Line';
import base64encode from './base64encode'
import './style.less'

const Option = Select.Option;

const clsPrefix = 'taobao-panel'

const defaultTkl = '￥Do39YvZOJEq￥'
const defaultImage = '//img.alicdn.com/i4/2939922051/O1CN01i12Oqd1R1OtyrrCIS_!!0-item_pic.jpg'
const defaultDomain = 'tbkdu'

export default function TaobaoPanel() {

  const [tkl, setTkl] = useState(defaultTkl)
  const [image, setImage] = useState(defaultImage)
  const [domain, setDomain] = useState(defaultDomain)
  const tbk = encodeTklAndImage(tkl, image)
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [needConvert, setNeedConvert] = useState(false);
  
  let _tbkLink = `https://${domain}.kuaizhan.com/?key=${tbk}`;
  const [tbkLink, setTbkLink] = useState(_tbkLink);

  const { data = { data: { list: [] } }, error } = useSWR('/site/ajax-list-site-v1?page=1&perpage=10', async url => fetch(url).then(res => res.json()))

  useStatistic('tbk-token-generate');
  
  function encodeTklAndImage(tkl: string, image?: string) {
    return base64encode(JSON.stringify({
      tkl,
      image,
    }))
  }

  function handleImage(e: React.ChangeEvent<HTMLInputElement>) {

    const url = e.target.value

    if (url.indexOf('kuaizhan.com') > -1) {
      // message.error('图片域名不合法')
      // return
    }

    setImage(e.target.value)
  }

  const inputStyle = {
    width: '407px',
  }

  const selfSites = data.data.list || [];
  const sites = [{
      domain: defaultDomain,
      name: '预览站点'
    }, ...selfSites]

  const disabled = !tkl || image.indexOf('kuaizhan.com') > -1
  const stepClass = classnames(
    {
      'step-disable': disabled
    }
  )

  console.log(_tbkLink, '_tbkLink')
  return (
    <div className={`${clsPrefix}`}>
      <div className={`${clsPrefix}__main`}>
        <div className={`${clsPrefix}__steps`}>
          <TbFormItem label='第一步: 输入淘口令'>
            <Input
              value={tkl}
              onChange={(e) => setTkl(e.target.value)}
              style={inputStyle} size='large'
              placeholder="必填"
            />
          </TbFormItem>
          <TbFormItem label='第二步: 输入商品图片地址'>
            <Input
                value={image}
                onChange={handleImage}
                style={inputStyle} size='large'
                placeholder="选填"
              />
              <div className='tip'>{
                image.indexOf('kuaizhan.com') > -1 ? '图片违规：含有kuaizhan.com，请重新输入商品图片地址' : '如何获取商品图片地址？ 扫描下方二维码联系客服人员'
              }</div>
          </TbFormItem>
          <TbFormItem
            label={
              <>
                <span>第三步: 选择站点</span>
                <a target='_blank' href='/v3/site/' className='create-site'>没有站点？立即创建淘客中间页模板站点&gt;&gt;</a>
              </>
            }
            className={stepClass}
          >
            <Select
              onChange={(value: string) => !disabled && setDomain(value)}
              style={inputStyle} size='large'
              value={domain}
            >
              {sites.map(site => (
                <Option value={site.domain}>{site.name}</Option>
              ))}
            </Select>
            <div className='tip'>*注意：测试站点仅用于演示，如需生成推广页，请选择您的个人站点</div>
          </TbFormItem>
          <TbFormItem
            label="第四步: 一键生成推广页链接"
            className={stepClass}
          >
            <Checkbox
              checked={needConvert}
              onChange={e => {
                setNeedConvert(e.target.checked)
              }}
            >
              复制并生成短链接
            </Checkbox>
            <TbButton
              theme="primary"
              content="一键生成推广页链接"
              onClick={() => {
                setLoading(true)
                if (needConvert) {
                  generateShortUrl({
                    type: 5,
                    urls: [_tbkLink]
                  // @ts-ignore
                  }).then((data: {urls: Array<string>}) => {
                    _tbkLink = data.urls[0];
                    setTbkLink(_tbkLink)
                  })
                } else {
                  setTbkLink(_tbkLink)
                }
                
                setTimeout(() => {
                  setLoading(false)
                  setVisible(true)
                }, 300)
               
              }}
              disabled={disabled}
              width="271px"
            />
          </TbFormItem>
          <TbFormItem
            label='第五步: 完成：预览，复制页面地址'
            className={stepClass}
          >
            <CopyToClipboard text={tbkLink}>
              <TbButton 
                disabled={disabled}
                theme="primary"
                width="271px"
                onClick={() => {
                  useClickStatistic('copy-page-address', 'copy-page-address-button');
                  message.success('复制成功');
                }}
                content="复制页面地址"
              />
            </CopyToClipboard>
          </TbFormItem>
        </div>
        <Line />
        <div className={`${clsPrefix}__preview`}>
          <p>推广页面预览</p>
          <iframe src={_tbkLink}></iframe>
        </div>
      </div>
      <div className="contact-us">
        <p>有问题？添加客服微信，快速解决</p>
        <div className="contact-us__main">
          <img src='//pic.kuaizhan.com/g3/a6/f6/f534-e977-4cf9-9b73-10ee38536a4771' />
          <Line height='33px' />
          <div>
            温馨提示，创建推广链接需要满足以下条件哦~<br/>
            1. 有开通尊享版套餐的个人站点<br/>
            2. 个人站点需要认证且发布<br/>
            3. 站点需要JS组件及代码<br/>
          </div>
        </div>
      </div>
      {loading && <PageLoading />}
      <Modal
        title={null}
        visible={visible}
        width={365}
        // height={250}
        centered
        footer={null}
        onCancel={() => setVisible(false)}
      >
        <Result 
          status="success"
          title="链接生成成功"
          subTitle="预览若有问题，请添加页面底部客服微信"
        ></Result>
        <Button onClick={() => setVisible(false)} size='large' type='danger' block>确定</Button>
      </Modal>
    </div>
  )
}